'use strict'

import axios from 'axios'

export default {
    findAll() {
        return axios.get('/api/users')
    },
    uploadUserFile(file) {
        return axios.post('/api/users/upload', {
            fileData: file
        })
    },
    uploadUserUpdateFile(file) {
        return axios.post('/api/users/csv-update', {
            fileData: file
        })
    }
}
